import { debounce } from 'lodash';

/**
 * @Mixin RemoteFilterPagination
 * It requires a "loadData" method and that the remote data comes with a "pagination" property
 */
export default (paginationConfig) => ({
  data() {
    return {
      listData: [],
      filteredList: [],
      searchFilter: '',
      currentPage: 1,
      pageSize: 10,
      pageSizes: [10, 20, 50, -1],
      totalRows: 0,
      totalPages: 1,
      ...paginationConfig,
    };
  },
  methods: {
    postLoadRemoteData(remoteData) {
      const { pagination } = remoteData;
      this.totalRows = Number.parseInt(pagination.totalItems, 10);
      this.totalPages = Number.parseInt(pagination.totalPages, 10);
    },
    changePage(newPage) {
      if (newPage !== this.currentPage) {
        this.currentPage = newPage;
        this.loadRemoteData();
      }
    },
    changePageSize(newPageSize) {
      if (newPageSize !== this.pageSize) {
        this.pageSize = newPageSize;
        this.loadRemoteData();
      }
    },
    paginationConfigChanged(pagination) {
      this.changePage(pagination.page);
      this.changePageSize(pagination.pageSize);
    },
    loadRemoteData() {
      typeof this.loadData === 'function' && this.loadData();
    },
  },
  computed: {
    isEmptyList() {
      return !this.listData || this.listData.length === 0;
    },
    shouldShowPagination() {
      return this.totalRows > this.pageSize;
    },
  },
  watch: {
    searchFilter() {
      this.debouncedSearchFunds();
    },
  },
  created() {
    this.debouncedSearchFunds = debounce(() => {
      this.currentPage = 1;
      return this.loadRemoteData();
    }, 700);
  },
});
